import { Skeleton } from '@mui/material';
import React from 'react';

const ValueByDateGridLoader = () => (
    <Skeleton
        variant="rectangular"
        sx={{
            width: '100%',
            height: '7rem',
            mt: '1em',
            borderRadius: '4px',
        }}
    />
);

export default ValueByDateGridLoader;
